import BaseClient from '../BaseClient';
import type {
    CalendlyClientInterface,
    GetEventTypesParams,
    UpdateCalendlyGroupMappingParams,
} from './calendlyClient.types';

export default class CorporateCalendlyClient extends BaseClient implements CalendlyClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getEventTypes(params?: GetEventTypesParams) {
        const url = `/api/v3/teams/${this.teamId}/calendly/event-types`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getGroupMapping(groupId: string) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/calendly-mapping`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateGroupMapping(groupId: string, data: UpdateCalendlyGroupMappingParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${groupId}/calendly-mapping`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }
}
